import React, { createContext, ReactNode, useState } from "react";

interface GeminiChatContextType {
  setShowAIWindow: (e: boolean) => void;
  showAIWindow: boolean;
}

export const GeminiChatContext = createContext<GeminiChatContextType | undefined>(
  undefined
);

interface GeminiChatProviderProps {
  children: ReactNode;
}

export const GeminiChatProvider: React.FC<GeminiChatProviderProps> = ({ children }) => {
  const [showAIWindow, setShowAIWindow] = useState<boolean>(false);

  const contextValue = {
    setShowAIWindow,
    showAIWindow,
  };

  return (
    <GeminiChatContext.Provider value={contextValue}>
      {children}
    </GeminiChatContext.Provider>
  );
};
